import React, { useState, useEffect } from 'react';
import {
    Grid, Switch, Typography, Button, TextField,CircularProgress, Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
    getInvoiceSetting,
    updateInvoiceSetting,
    createInvoiceSetting
} from './actions/administration';
import {
    showErrorToast,
    showSuccessToast
} from '../../../common/components/Helper/Utils';
import { SpinnerRoundFilled } from "spinners-react";

const useStyles = makeStyles(() => ({
    gridItemTwo: {
        display: "flex",
        alignItems: "center"
    },
     gridItemThree: {
        display: "flex",
        alignItems: "center",
        marginLeft: '1.5%'
    },
}));
const formatTaxPercentage = (value) => {
  const floatVal = parseFloat(value);
  if (Number.isNaN(floatVal)) return '';
  return Number.isInteger(floatVal) ? `${floatVal}` : `${floatVal}`;
};

const InvoiceSettings = () => {
    const classes = useStyles();
    const [enable, setEnable] = useState(true);
    const [inventoryDetails, setInventoryDetails] = useState([]);
    const [aggError, setAggError] = useState(false);
    const [enableFeature, setEnableFeature] = useState({
        pagenumberenable: false,
        inventoryitemnumberenable: false,
        includesalextax: false,
        showtradeinventory: false,
        showinventoryid: false,
        ShowPaymentType: false,
        ShowPaymentTerm: false,
        showdescription: false,
        showaggregated: false,
        showlegalfooter: false,
        phone: false,
        email: false,
        invoiceWireDetails: false
        // showinvoicesoldprice: false
    });
    const [legalError, setLegalError] = useState(false);
    const [legalText, setLegalText] = useState('');
    const [taxPercentage, setTaxPercentage] = useState('');
    const [settingsView, setSettingsView] = useState(false);
    const [loader, setloader] = useState(true);
    const [aggregatedFields, setAggregatedFields] = useState({
        modelNo: true,
        inventoryTitle: true,
        links: true,
        box: true,
        warranty: true,
        warrantyDate: true,
    });

    useEffect(() => {
        getInvoiceSettingData();
    }, []);
    const handleAggregatedChange = (field) => (event) => {
     const updated = {
        ...aggregatedFields,
        [field]: event.target.checked,
        };

        setAggregatedFields(updated);
        const isAnyChecked =
            updated.modelNo ||
            updated.inventoryTitle ||
            updated.links ||
            updated.box ||
            updated.warranty ||
            updated.warrantyDate;

        if (isAnyChecked) {
            setAggError(false);
        }
    };

    const getInvoiceSettingData = () => {
        setloader(true);
        getInvoiceSetting((err, response) => {
            if (response?.data?.length > 0) {
                const data = response.data[0];
                setInventoryDetails(data);
                setEnableFeature({
                    pagenumberenable: data.is_pagenumber,
                    inventoryitemnumberenable: data.is_inventory_itemno,
                    includesalextax: data.is_include_salestax,
                    showtradeinventory: data.is_showtrade,
                    showinventoryid: data.is_show_inventory_id,
                    showdescription: data.is_show_description,
                    showaggregated: data.is_show_aggregated_description,
                    showlegalfooter: data.is_legal_disclaimer_footer,
                    ShowPaymentType: data.is_show_payment_type,
                    ShowPaymentTerm: data.is_show_payment_term,
                    phone: data.phone,
                    email: data.email,
                    invoiceWireDetails: data.invoice_wiredetails
                });
                setAggregatedFields({
                    modelNo: data.agg_model_no ?? true,
                    inventoryTitle: data.agg_inventory_title ?? true,
                    links: data.agg_links ?? true,
                    box: data.agg_box ?? true,
                    warranty: data.agg_warranty ?? true,
                    warrantyDate: data.agg_warranty_date ?? true,
                });

                setLegalText(data.legal_disclaimer_footer || '');
                setTaxPercentage(
                data.tax_percentage !== undefined && data.tax_percentage !== null
                    ? parseFloat(data.tax_percentage).toString()
                    : ''
                );
            }
                setloader(false);
        })
    };

    const handleToggle = (key) => {
        setEnableFeature((prev) => {
            let newState = { ...prev };

            if (key === "showdescription") {
                newState.showdescription = !prev.showdescription;

                if (newState.showdescription) {
                    newState.showaggregated = false;
                }
            }

            else if (key === "showaggregated") {
                newState.showaggregated = !prev.showaggregated;

                if (newState.showaggregated) {
                    newState.showdescription = false;
                }

                // reset fields if turned OFF
                if (!newState.showaggregated) {
                    setAggregatedFields({
                        modelNo: true,
                        inventoryTitle: true,
                        links: true,
                        box: true,
                        warranty: true,
                        warrantyDate: true,
                    });
                }
            }

            else {
                newState[key] = !prev[key];
            }

            // existing logic
            if (key === "showlegalfooter" && !newState.showlegalfooter) {
                setLegalText('');
            }

            if (key === 'includesalextax' && !newState.includesalextax) {
                setTaxPercentage('');
            }
            return newState;
        });
    };

    const handleOnEdit = () => {
        setEnable(false);
    };

   const submitData = () => {
    setSettingsView(true)
    if (enableFeature.showaggregated) {
        const isAnyChecked =
            aggregatedFields.modelNo ||
            aggregatedFields.inventoryTitle ||
            aggregatedFields.links ||
            aggregatedFields.box ||
            aggregatedFields.warranty ||
            aggregatedFields.warrantyDate;

        if (!isAnyChecked) {
            setAggError(true);     
            setSettingsView(false);
            return;
        }
    }
    if (
        enableFeature.showlegalfooter &&
        (!legalText.trim() || legalText.length > 250)
    ) {
        setLegalError(true);
        setSettingsView(false);
        return;
    }
    const userDetails = JSON.parse(window.sessionStorage.getItem('userDetails') || '{}');
    const accountid = window.sessionStorage.getItem('accountId');
    const numericTax = parseFloat(taxPercentage.replace('%', ''));

    if (enableFeature.includesalextax &&(isNaN(numericTax) || numericTax < 0 || numericTax > 100))
    {
    showErrorToast("Please enter a valid tax percentage (0–100)");
    return;
    }

    const newTax = enableFeature.includesalextax
    ? parseFloat(parseFloat(taxPercentage.replace('%', '')).toFixed(2))    : 0;

    const payload = {
        accountid,
        is_pagenumber: enableFeature.pagenumberenable,
        is_inventory_itemno: enableFeature.inventoryitemnumberenable,
        is_include_salestax: enableFeature.includesalextax,
        is_showtrade: enableFeature.showtradeinventory,
        is_show_inventory_id: !!enableFeature.showinventoryid,
        is_show_description: !!enableFeature.showdescription,
        is_show_aggregated_description: !!enableFeature.showaggregated,
        is_legal_disclaimer_footer: !!enableFeature.showlegalfooter,
        is_show_payment_type: !!enableFeature.ShowPaymentType,
        is_show_payment_term: !!enableFeature.ShowPaymentTerm,
        agg_model_no: !!aggregatedFields.modelNo,
        agg_inventory_title: !!aggregatedFields.inventoryTitle,
        agg_links: !!aggregatedFields.links,
        agg_box: !!aggregatedFields.box,
        agg_warranty: !!aggregatedFields.warranty,
        agg_warranty_date: !!aggregatedFields.warrantyDate,
        phone: enableFeature.phone,
        email: enableFeature.email,
        invoice_wiredetails: enableFeature.invoiceWireDetails,

        legal_disclaimer_footer: !!enableFeature.showlegalfooter
            ? legalText
            : null,
tax_percentage: enableFeature.includesalextax
  ? parseFloat(taxPercentage)
  : null,
        notes: "",
        userid: userDetails?.userId,
        isTaxChanged: parseFloat(inventoryDetails.tax_percentage || 0) !== newTax
    };

    if (inventoryDetails && inventoryDetails.id) {
        // Edit (Update)
        payload.id = inventoryDetails.id;
        updateInvoiceSetting(payload, (err, response) => {
            if (response?.status === 1) {
                setSettingsView(false)
                setEnable(true);
                setLegalError(false);
                getInvoiceSettingData();
                showSuccessToast("Updated Successfully");
            } else {
                showErrorToast("Update Failed");
            }
        }).catch((e) => {
            console.error("Update error:", e);
            showErrorToast("Update Failed");
        });
    } else {
        // Create
        createInvoiceSetting(payload, (err, response) => {
            if (response?.status === 1) {
                setSettingsView(false)
                setEnable(true);
                getInvoiceSettingData();
                showSuccessToast("Created Successfully");
            } else {
                showErrorToast("Creation Failed");
            }
        }).catch((e) => {
            console.error("Create error:", e);
            showErrorToast("Creation Failed");
        });
    }
};
    if (loader) {
            return (
                <div className="d-spinner">
                    <SpinnerRoundFilled
                        size={51}
                        thickness={125}
                        speed={80}
                        color="rgba(57, 107, 172, 1)"
                        className="spp"
                        enabled={loader}
                    />
                </div>
                );
    }
    return (
        <Grid item xs={12} md={6}>
            <div style={{ marginTop: '20px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="flex-end">
                            {enable && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleOnEdit}
                                    className="primary-bg color-white text-center1 form-width-20"
                                >
                                    EDIT
                                </Button>
                            )}
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" component="p" className="primary-text uppercase">
                            Invoice Settings
                        </Typography>
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Display Page Number</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.pagenumberenable}
                            disabled={enable}
                            onChange={() => handleToggle('pagenumberenable')}
                        />
                    </Grid>
                     <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Inventory ID</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.showinventoryid}
                            disabled={enable}
                            onChange={() => handleToggle('showinventoryid')}
                        />
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Display Inventory Item Number</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.inventoryitemnumberenable}
                            disabled={enable}
                            onChange={() => handleToggle('inventoryitemnumberenable')}
                        />
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Trade Inventory</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.showtradeinventory}
                            disabled={enable}
                            onChange={() => handleToggle('showtradeinventory')}
                        />
                    </Grid>
                                        <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Invoice Payment PDF Configuration</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.invoiceWireDetails}
                            disabled={enable}
                            onChange={() => handleToggle('invoiceWireDetails')}
                        />
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Payment Type</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.ShowPaymentType}
                            disabled={enable}
                            onChange={() => handleToggle('ShowPaymentType')}
                        />
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Payment Term</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.ShowPaymentTerm}
                            disabled={enable}
                            onChange={() => handleToggle('ShowPaymentTerm')}
                        />
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Phone Number</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.phone}
                            disabled={enable}
                            onChange={() => handleToggle('phone')}
                        />
                    </Grid>
                        <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Email Address</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.email}
                            disabled={enable}
                            onChange={() => handleToggle('email')}
                        />
                    </Grid>

                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Include Default Sales Tax Calculation</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.includesalextax}
                            disabled={enable}
                            onChange={() => handleToggle('includesalextax')}
                        />
                    </Grid>

                  <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                    <Typography variant="caption">Tax Percentage</Typography>
                  </Grid>
                    <Grid item xs={6} md={7}>
                     <TextField
                        sx={{ maxWidth: 200 }} 
                        type='text'
                        value={taxPercentage}
                        onChange={(e) => {
                            let value = e.target.value.replace('%', '');
                            if (
                            value === '' ||
                            (/^\d{1,3}(\.\d{0,2})?$/.test(value) && parseFloat(value) <= 100)
                            ) {
                            setTaxPercentage(value);
                            }
                        }}
                        disabled={enable}  
                        placeholder="Enter tax percentage"
                        InputProps={{
                            endAdornment: <span>%</span>
                        }}
                        />

                    </Grid>
                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show Description</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.showdescription}
                            disabled={enable}
                            onChange={() => handleToggle('showdescription')}
                        />
                    </Grid>
                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show aggregated product details</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.showaggregated}
                            disabled={enable}
                            onChange={() => handleToggle('showaggregated')}
                        />
                    </Grid>
                    {enableFeature.showaggregated && (
                   
                    <Grid container className={classes.gridItemThree}>
                          <>
                        <Grid item xs={6} md={5}>
                        <Typography variant="caption">Model No</Typography>
                        </Grid>
                        <Grid item xs={6} md={7}>
                        <Checkbox
                            checked={aggregatedFields.modelNo}
                            onChange={handleAggregatedChange("modelNo")}
                            disabled={enable}
                        />
                        </Grid>

                        <Grid item xs={6} md={5}>
                        <Typography variant="caption">Inventory Title</Typography>
                        </Grid>
                        <Grid item xs={6} md={7}>
                        <Checkbox
                            checked={aggregatedFields.inventoryTitle}
                            onChange={handleAggregatedChange("inventoryTitle")}
                            disabled={enable}
                        />
                        </Grid>

                        <Grid item xs={6} md={5}>
                        <Typography variant="caption">Links</Typography>
                        </Grid>
                        <Grid item xs={6} md={7}>
                        <Checkbox
                            checked={aggregatedFields.links}
                            onChange={handleAggregatedChange("links")}
                            disabled={enable}
                        />
                        </Grid>

                        <Grid item xs={6} md={5}>
                        <Typography variant="caption">Box</Typography>
                        </Grid>
                        <Grid item xs={6} md={7}>
                        <Checkbox
                            checked={aggregatedFields.box}
                            onChange={handleAggregatedChange("box")}
                            disabled={enable}
                        />
                        </Grid>

                        <Grid item xs={6} md={5}>
                        <Typography variant="caption">Warranty</Typography>
                        </Grid>
                        <Grid item xs={6} md={7}>
                        <Checkbox
                            checked={aggregatedFields.warranty}
                            onChange={handleAggregatedChange("warranty")}
                            disabled={enable}
                        />
                        </Grid>

                        <Grid item xs={6} md={5}>
                        <Typography variant="caption">Warranty Date</Typography>
                        </Grid>
                        <Grid item xs={6} md={7}>
                        <Checkbox
                            checked={aggregatedFields.warrantyDate}
                            onChange={handleAggregatedChange("warrantyDate")}
                            disabled={enable}
                        />
                        </Grid>
                    </>
                    </Grid>
                    )}
                    {enableFeature.showaggregated && aggError && (
                        <Grid item xs={12}>
                            <span style={{ color: "red", fontSize: "12px" }}>
                                Please select at least one aggregated details
                            </span>
                        </Grid>
                    )}
                    <Grid item xs={6} md={5} className={classes.gridItemTwo}>
                        <Typography variant="caption">Show legal disclaimer footer</Typography>
                    </Grid>
                    <Grid item xs={6} md={7}>
                        <Switch
                            checked={enableFeature.showlegalfooter}
                            disabled={enable}
                            onChange={() => handleToggle('showlegalfooter')}
                        />
                    </Grid>
                    {enableFeature.showlegalfooter && (
                        <>
                            <Grid item xs={12}>
                                <textarea
                                    style={{
                                        width: "100%",
                                        minHeight: "80px",
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        resize: "none",
                                        fontFamily: "inherit"
                                    }}
                                    placeholder="Enter the legal disclaimer text"
                                    value={legalText}
                                    disabled={enable || !enableFeature.showlegalfooter}
                                   onChange={(e) => {
                                        // let value = e.target.value;
                                        let value = e.target.value.replace(/[\r\n]+/g, " "); 
                                        if (value.length > 250) {
                                            value = value.slice(0, 250); 
                                            setLegalError(true);
                                        } else {
                                            setLegalError(false);
                                        }
                                        setLegalText(value);
                                    }}
                                />
                                {legalError && !enable && (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                        The maximum allowed character count is 250.
                                    </span>
                                )}

                                {legalError && legalText.trim() === '' && (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                        Please enter legal disclaimer text
                                    </span>
                                )}

                            </Grid>
                        </>
                    )}
                    {!enable && (
                        <>
                            <Grid item xs={6} md={3}>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setEnable(true);
                                        getInvoiceSettingData();
                                    }}
                                    className="primary-bg color-white text-center1 form-width-20"
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={submitData}
                                    className="primary-bg color-white text-center1 form-width-20"
                                    disabled={settingsView}
                                      endIcon={
                                     settingsView ? ( <CircularProgress style={{ width: 22, height: 22, color: "#fff" }} />
                                                                                                    ) : null
                                                                                                    } 
                                >
                                    Update
                                </Button>
                            </Grid>
                        </>
                    )}
                </Grid>
            </div>
        </Grid>
    );
};

export default InvoiceSettings;
